import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    create: {
      invalidBeneficiary:
        'This is probably not a beneficial owner. Please check the information or go back.',
    },
    directorLabel: {
      description:
        'The beneficial owner will legally represent the company or have a mandate as president or manager.',
      title: 'Does he or she occupy a management role?',
    },
    edit: {
      invalidBeneficiary:
        'This is probably not a beneficial owner. Please check the information or delete the beneficial owner.',
    },
    emailAlreadyExists:
      'This e-mail address is already used by one of the beneficial owners',
    emailLabel: 'E-mail of the beneficial owner',
    firstNameLabel: 'First Name',
    genderLabel: 'Gender',
    lastNameLabel: 'Last Name',
    no: 'No',
    shareholderLabel: {
      description:
        'The beneficial owner will be a shareholder of the company, directly or indirectly.',
      title: 'Is he or she a shareholder?',
    },
    validBeneficiary:
      'He/She will receive an email notification to send us proof of identity. This document is required to open your pro Shine account.',
    yes: 'Yes',
  },
  fr: {
    create: {
      invalidBeneficiary:
        "Il ne s'agit probablement pas d'un bénéficiaire effectif. Veuillez vérifier les informations ou revenir en arrière.",
    },
    directorLabel: {
      description:
        "Le bénéficiaire effectif représentera légalement l'entreprise ou disposera d'un mandat de président·e ou de gérant·e.",
      title: 'Occupe-t-il ou elle un rôle de direction',
    },
    edit: {
      invalidBeneficiary:
        "Il ne s'agit probablement pas d'un bénéficiaire effectif. Veuillez vérifier les informations ou supprimer le bénéficiaire effectif.",
    },
    emailAlreadyExists:
      "Cette adresse e-mail est déjà utilisée par l'un des bénéficiaires effectifs",
    emailLabel: 'E-mail du bénéficiaire effectif',
    firstNameLabel: 'Prénom',
    genderLabel: 'Civilité',
    lastNameLabel: 'Nom',
    no: 'Non',
    shareholderLabel: {
      description:
        "Le bénéficiaire effectif sera actionnaire de l'entreprise, directement ou indirectement.",
      title: "Occupe-t-il ou elle un rôle d'actionnaire ?",
    },
    validBeneficiary:
      'Il·Elle recevra une notification par email pour nous transmettre un justificatif d’identité. Ce document est obligatoire pour ouvrir votre compte pro Shine.',
    yes: 'Oui',
  },
} as const);
